import { render, staticRenderFns } from "./OverviewInbox.vue?vue&type=template&id=225bc30c&scoped=true"
import script from "./OverviewInbox.vue?vue&type=script&lang=ts"
export * from "./OverviewInbox.vue?vue&type=script&lang=ts"
import style0 from "./OverviewInbox.vue?vue&type=style&index=0&id=225bc30c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225bc30c",
  null
  
)

export default component.exports